/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AddressRequest } from './address-request';

/**
 * Detailed company model serializer.
 */
export interface CompanyRequest {
  name: string;
  organization_number: string;
  tags?: Array<string>;
  address?: AddressRequest;
  website?: string;
  requires_logo?: boolean;
}
